import React from "react";
import {Select} from "@amzn/awsui-components-react";
import Icon from "@amzn/awsui-components-react/polaris/icon";

export default class AsyncFuncBackedSelect extends React.Component {
  constructor(props) {
    super(props);
    this.props = props
    this.state = {selectedItem: this.props.selectedOption || null, itemOptions: [], loadingState: "loading"}

    this.updateOptions = this.updateOptions.bind(this)
  }

  componentDidMount() {
    this.updateOptions()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props !== prevProps) {
      this.updateOptions()
    }

    if (this.props.selectedOption && this.props.selectedOption !== prevProps.selectedOption) {
        this.setState({selectedItem: this.props.selectedOption})
      }
  }

  updateOptions() {
    this.setState({loadingState: "loading"})
    if (!this.props.hasOwnProperty('fetchItems')) {
      this.setState({itemOptions: [], loadingState: "finished"})
      return
    }

    this.props.fetchItems().then(items => {
      this.setState({
        itemOptions: items,
        loadingState: "finished"
      })
    }).catch((e) => {
      console.log("Error fetching items in query: " + this.props.listQuery + ": ", e)
      this.setState({
        loadingState: "error"
      })
    })
  }

  render() {
    const invalid = this.props.required === true && this.props.hasSubmitted === true && this.state.selectedItem === null;
    return (
      <div>
        <Select
          filteringType="auto"
          {...this.props}
          options={this.state.itemOptions}
          statusType={this.state.loadingState}
          recoveryText="Retry"
          invalid={invalid}
          selectedOption={this.state.selectedItem}
          onChange={e => {
            this.setState({selectedItem: e.detail.selectedOption})
            if (this.props.onChange) {
              this.props.onChange(e)
            }
          }}
          onRecoveryClick={e => {
            this.updateOptions()
          }}
        />
        {invalid ?
          <span className="error-text awsui-util-pt-xs display-block awsui-form-field-description">
            <Icon name="status-warning"/> Required field</span> : null}
      </div>
    )
  }
}